import React, { useState } from "react";
import "./style.css";
import locationIcon from "./images/location.svg";
import profileImg from "./images/profile-img.svg";
import deliveryIcon from "./images/delevery.svg";
import notLogedinGif from "./images/not-logedin.svg";
import { signout, isAuthenticated } from "../../pages/login/auth/auth";
import { Redirect } from "react-router-dom";

export default function Menu() {
  const [loged, setLoged] = useState(false);

  const afterLogout = () => setLoged(true);

  const handleLogout = () => {
    return signout(afterLogout);
  };

  const { data } = isAuthenticated();

  return (
    <div className="menu">
      <div className="menu-first">
        {data ? (
          <div className="loged-in">
            <div className="flex">
              <img src={profileImg} alt="profile-img" />
              <div className="user-name">
                {isAuthenticated() && (
                  <div>
                    <h3>{data.user.name}</h3>
                    <h3>{data.user.number}</h3>
                  </div>
                )}
              </div>
            </div>
            <button className="login-btn" onClick={handleLogout}>
              <h3>Log-Out</h3>
            </button>
            {data && (
              <div>
                {data.user.role === "admin" && (
                  <a href="/admin">
                    <h3>Admin</h3>
                  </a>
                )}
              </div>
            )}
          </div>
        ) : (
          <div className="not-loged-in">
            <img
              src={notLogedinGif}
              alt="not-loged-in"
              className="not-logedin-gif"
            />
            <h3>
              <center>Oops! You aren't logged In</center>
            </h3>
            <a href="/login">
              <button className="login-btn">
                <h3>Login</h3>
              </button>
            </a>
          </div>
        )}
        {loged && <Redirect to="/" />}
        <div className="location-div">
          <div className="location">
            <img src={locationIcon} alt="location-icon" />
            <p>
              <b>We deliver all over PATNA​</b>
            </p>
          </div>
          <div className="location">
            <img src={deliveryIcon} alt="delivery-truck" />
            <p>
              <b>Same Day Delivery (Free*)</b>
            </p>
          </div>
        </div>
      </div>
      <div className="menu-second">
        <ul>
          <li>
            <a href="/">
              <h3>Home</h3>
            </a>
          </li>
          <li>
            <a href="/cart">
              <h3>My cart</h3>
            </a>
          </li>
          {/* <li>
            <a href="/subscription">
              <h3>My subscription</h3>
            </a>
          </li> */}
          <li>
            <a href="/my-order">
              <h3>My order</h3>
            </a>
          </li>

          <li>
            <a href="/categories">
              <h3>Shop by Categories</h3>
            </a>
          </li>
          <li>
            <a href="/shop-on-whatsapp">
              <h3>Shop On WhatsApp</h3>
            </a>
          </li>
          <li>
            <a href="/sbg-membership">
              <h3>Membership</h3>
            </a>
          </li>
          <li>
            <a href="/faq">
              <h3>FAQs</h3>
            </a>
          </li>
          <li>
            <a href="/b2b">
              <h3>‍B2B</h3>
            </a>
          </li>
          <li>
            <a href="/support">
              <h3>Support</h3>
            </a>
          </li>
          <li>
            <a href="/about-us">
              <h3>About Us</h3>
            </a>
          </li>
          <li>
            <a href="/return-policy">
              <h3>Return & Refund Policy</h3>
            </a>
          </li>
          <li>
            <a href="/privacy-policy">
              <h3>Privacy Policy</h3>
            </a>
          </li>
          <li>
            <a href="/terms-conditions">
              <h3>Terms and Conditions</h3>
            </a>
          </li>
          <li>
            <a href="/register-my-store">
              <h3>Sell On SabjiGrocery</h3>
            </a>
          </li>
          {data && (
            <div>
              {data.user.role === "delivery-boy" && (
                <li>
                  <a href="/delivery-boy">
                    <h3>Today Orders</h3>
                  </a>
                </li>
              )}
            </div>
          )}
        </ul>
        {/* <p className="menu-note">
          Please note that you are accessing the BETA Version of
          www.SabjiGrocery.com
          , If you find any problem or Error while using the
          application feel free to contact us +91-75449 90999.
        </p> */}
      </div>
    </div>
  );
}
